import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'hooks/useForm';
import { createClient } from '@redux/features/clientsSlice';
import { clientSchema } from 'constants/formValidationSchemas/clientSchema';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import styles from 'pages/Database/Clients/Clients.scss';

export const CreateClient = ({ onClientCreated }) => {
  const { isLoading, error } = useSelector((state) => state.clients);
  const dispatch = useDispatch();

  const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, isValid, resetForm } = useForm(
    {
      initialValues: { surname: '', name: '' },
      validationSchema: clientSchema,
      onSubmit: async (values) => {
        const result = await dispatch(createClient(values));
        if (result.meta?.requestStatus === 'fulfilled') {
          resetForm();
          if (onClientCreated) {
            onClientCreated(result.payload);
          }
        }
      },
      status: {
        isLoading: isLoading,
        error: error,
      },
    }
  );

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <Input
        className={styles.input}
        value={values.surname}
        name='surname'
        placeholder='Прізвище'
        errorText={touched.surname && errors.surname}
        invalid={touched.surname && !!errors.surname}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Input
        className={styles.input}
        value={values.name}
        name='name'
        placeholder="Ім'я"
        errorText={touched.name && errors.name}
        invalid={touched.name && !!errors.name}
        onChange={handleChange}
        onBlur={handleBlur}
      />
      <Button text='Створити' type='submit' disabled={!isValid || isSubmitting} no3D smallStyle />
    </form>
  );
};
